import { render } from "./LeadFollowup.vue?vue&type=template&id=38ae38a1&scoped=true"
import script from "./LeadFollowup.vue?vue&type=script&lang=js"
export * from "./LeadFollowup.vue?vue&type=script&lang=js"

import "./LeadFollowup.vue?vue&type=style&index=0&id=38ae38a1&scoped=true&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ae38a1"]])

export default __exports__